/** Missing scores are not failures. A genuine zero remains a scored attempt. */
export const isScored = (score: unknown): score is number => typeof score === 'number' && Number.isFinite(score);
export type ScoredRow = { overall_score?: number | null };
export function scoreStatistics(rows: readonly ScoredRow[] | null | undefined) {
  const scores = (rows ?? []).map(row => row.overall_score).filter(isScored);
  return {
    count: scores.length,
    average: scores.length ? scores.reduce((sum, score) => sum + score, 0) / scores.length : null,
    best: scores.length ? Math.max(...scores) : null,
  };
}
export const averageScore = (rows: readonly ScoredRow[] | null | undefined): number | null => {
  const average = scoreStatistics(rows).average;
  return average === null ? null : Math.round(average);
};
